{
  "name": "demo",
  "hostname": "demo.safarilaw.com",
  "default": null,
  "development": false,
  "production": true,
  "applicationName": "Safari SOP",
  "sourceVersion": "925a778bb7dffaa61f92ef338a15bc52cd99c3db",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.demo.safarilaw.com/_api/comanage/",
    "apiRootLpms": "https://@.demo.safarilaw.com/_api/lpms/",
    "apiRootSquirrel": "https://@.demo.safarilaw.com/_api/squirrel/",
    "apiRootRms": "https://@.demo.serveport.com/_api/rms/",
    "serveportPortalRoot": "https://app.demo.serveport.com/serve/",
    "serveportAgencyPortalUrl": "https://agency.demo.serveport.com/"
  },
  "auth0": {
    "authorityRoot": "safarilaw-demo.auth0.com",
    "clientId": "netNcjkASxGnsul35rw6qeYm6R8mbAO1",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.demo.safarilaw.com/_api/maintenance/",
    "code": "4M5ANviM0RwUqsdw1DpfPg5ygi6luDkbARDd22N3x2OfAzFuWH3POw==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": false,
    "devExceptions": false,
    "enableMatterSubtypePicklistSettingsEditing": false,
    "showMatterSubtypePicklistSettings": false,
    "showCustomPicklistSettings": false,
    "enableCustomPicklistSettingsEditing": false,
    "inputRelativeValidation": true,
    "showServiceAccountSettings": true,
    "notificationBellEnabled": true,
    "enableCloneMatter": true,
    "enableServeportPortalEdit": true,
    "enableServiceOfProcessBusinessHours": true,
    "enableBlackMamba": true,
    "enableFederalBenefitExemptionStatus": true,
    "enableEmailFileViewer": true,
    "enableNonPdfIntakeUpload": false,
    "enablePdfTemplates": false,
    "enableTaskGroups": false
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "250f61b9-b88e-4ff9-a399-f086ecc3b480"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=63d6d53e-9809-4390-a97d-65693b28d1b5;IngestionEndpoint=https://eastus-1.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=e0511619-b1c0-408c-80f8-fc509441e942"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20,
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self"
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    },
    "ckeditor": {
      "key": "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MjQ1OTUxOTksImp0aSI6ImQ1NWI1Mjc0LTg0YTUtNDZmZC04N2E0LWFlYzZiNmUwOGE3YyIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwibGljZW5zZVR5cGUiOiJkZXZlbG9wbWVudCIsImZlYXR1cmVzIjpbIkRSVVAiXSwidmMiOiJlOGFlNTQ4NCJ9.oqxsFLsEfR0gmD4JFvTS5TgzpQ4IJ3BwZirvcVT55JzMJxksQcQ8x2UCqNJjtU_ULe3AhCaYNtLrpgJudG_FeQ"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "lpms",
        "name": "matters",
        "url": "signalr/matters"
      },
      {
        "api": "lpms",
        "name": "correspondences",
        "url": "signalr/correspondences"
      },
      {
        "api": "lpms",
        "name": "notifications",
        "url": "signalr/notifications"
      },
      {
        "api": "lpms",
        "name": "intake-files",
        "url": "signalr/intake-files"
      }
    ]
  }
}
